import React from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link } from 'react-router-dom';
import { toDate, fromNow } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';


const swalReact = withReactContent(swal);

const Badge = ({ titre, couleur }) => (
    <h6>
        <span className={`badge badge-pill ${couleur} text-uppercase mr-3`}>{titre}</span>
    </h6>
);


const LigneActu = ({
    type, dDate, objet, memo, nouveau, VoteFerme, EtatVotePro, NumReunion, EtatReu,l1,l2,TextVote,ico
}) => (
        <div className="list-group-item list-group-item-action" style={{padding:"10px",border:"1px solid #CCC"}} title={memo ? memo : ""}>
        {nouveau ? <span style={{ position: "absolute", top: 5, right: 5}} className="badge badge-pill badge-danger">new</span> : ""}
            <div className="media">
                <div className="media-body">
                    <strong>{objet}</strong><br/>
                    {toDate(dDate, 'LLL')}<br/>&nbsp;<br/>
                    <div  className="media-body text-center">

                    {TextVote.length>0 ? (
                    <Link to={{ pathname: `/MesInformations/MonAG/${NumReunion}` }} className="btn btn-outline-primary" style={{width:'80%'}}>
                        {TextVote}
                    </Link>
                    ) : ( null)} 
                        <span style={{fontWeight:"normal"}}>
                        <br/>{l1}<br/>&nbsp;<br/>
                        <p className={`${ico=='ALERTE' ? "card acc-valide-erreur" : ""} `}><span style={{fontWeight:"600"}}>
                            {ico=='OK' ? <i className='fa fa-lg fa-check text-success' style={{paddingLeft:'10px',paddingRight:'5px', fontSize:'1.2rem'}} /> : null}
                            {ico=='ALERTE' ? <i className='fa fa-exclamation-triangle fa-lg acc-ico-erreur' style={{color:'#DC3545',paddingLeft:'10px',paddingRight:'5px', fontSize:'1.2rem'}} /> : null}                    
                            {l2}</span>
                        </p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
);

const CardAG = ({
    LsReunions, Syn
}) => {
    const liste = [];

    if (LsReunions && LsReunions.length > 0) {
        LsReunions.forEach((reunion) => {
            const {
                DateDebut, Libelle, Nom, VoteFerme, Type, NumReunion, EtatVotePro,EtatReu, VoteFin
            } = reunion;
            if (Type === "AG" && EtatVotePro > 0 && Syn.VoteFormActifOk) {


                let d1 = new Date(VoteFin);
                let dh = new Date();
                let sdh = dh.toDateString();
                let d2 = new Date(sdh);
                let futur =0 
                d1>=d2 ? futur=1 : futur=0
                let nbd=Math.floor((d1-d2)/1000/60/60/24)
                let l1 = ""
                let l2 = ""
                let ico = "RIEN"
                let TextVote=''
        
                if (EtatReu != 1 && futur==1) {l1="Votes actuellement fermés"}
                if (EtatReu != 1 && futur==0) {l1=`Votes fermés depuis le ${toDate(VoteFin, 'DD/MM/YYYY')}`}
                if (EtatReu == 1) {l1=`Votes ouverts jusqu'au ${toDate(VoteFin, 'DD/MM/YYYY')}`}
        
                if (EtatReu != 1 && futur==1 && EtatVotePro==1) {l2=``}
                if (EtatReu != 1 && ( EtatVotePro==2 || EtatVotePro==3)) {l2=`Vos votes n'ont pas été validés`}
        
                if (EtatVotePro==4) {l2=`Vous avez validé vos votes`}
                if (EtatVotePro==5) {l2=`Votre formulaire a été receptionné par le syndic`}
                if (EtatVotePro==6) {l2=`Vos votes ont été recus et enregistrés par le syndic`}
        
                if (EtatReu == 1 && futur==1 && ( EtatVotePro==2 || EtatVotePro==3) && nbd==0) {l2=`C'est le dernier jour pour valider vos votes`}
                if (EtatReu == 1 && futur==1 && ( EtatVotePro==2 || EtatVotePro==3) && nbd>0) {l2=`Il vous reste ${nbd+1} jours pour valider vos votes`}
                if (EtatReu == 1 && ( EtatVotePro==1 )) {l2=`Vous pouvez commencer à voter`}
                if (EtatReu != 1 && futur==0 && EtatVotePro==1) {l2=`Vous n'avez pas voté par formulaire en ligne`}
        
        
                if ((EtatVotePro==2 || EtatVotePro==3)) {ico=`ALERTE`}
                if (EtatVotePro>=4) {ico=`OK`}
               
                if (EtatReu != 1 && ( EtatVotePro==1 )) {TextVote=`Ordre du Jour`}
                if (EtatReu == 1 && ( EtatVotePro==1 )) {TextVote=`Ordre du Jour et Votes`}
                if ( EtatVotePro==2 || EtatVotePro==3 || EtatVotePro==4 || EtatVotePro==6) {TextVote=`Ordre du Jour et Votes`}
                if ( EtatVotePro==5) {TextVote=`Ordre du Jour`} 
                // pas mis dans le else car risque de changement (pas de texte et donc pas de bouton)

                liste.push({
                    type: { titre: ' ', couleur: 'badge-reunion' },
                    dDate: DateDebut,
                    objet: Nom,
                    lien: {
                        pathname: '/MaCopropriete',
                        state: { Reunion: NumReunion, Vote: true },
                    },
                    adresse: reunion.Adresse,
                    VoteFerme: VoteFerme,
                    EtatVotePro: EtatVotePro,
                    NumReunion: NumReunion,
                    EtatReu: EtatReu,
                    l1:l1,
                    l2:l2,
                    TextVote:TextVote,
                    ico:ico
                });
            };
        });
    }

    const dateTemp = new Date();
    const dateMini = dateTemp.setFullYear(dateTemp.getFullYear() - 1);
    const listeOrdre = liste.sort((l1, l2) => new Date(l2.dDate).getTime() - new Date(l1.dDate).getTime());
    const listeFiltre = listeOrdre.filter(element => new Date(element.dDate).getTime() > dateMini);
    const lsActu = listeFiltre.map((ligne, i) => <LigneActu key={i} {...ligne} />);

    if (lsActu.length <1 ) return null;

    return (
        <Card Titre={CardAG.titleName} >
            {lsActu.length > 0 ? (
                <div className="list-group list-group-flush small">{lsActu}</div>
            ) : (
                <p className="card-text">
                    <i>Il n&apos;y a pas d&apos;AG récentes à afficher.</i>
                </p>
            )}

        </Card>
    );
};
CardAG.displayName = 'CardAG';
CardAG.titleName = 'Mes AG et votes';
CardAG.requiredProps = [
    'LsReunions', // Liste des réunions
];

function mapStateToProps({
    CopStore: {
        Cop: { LsReunions },
    },
    SynStore: { Syn },
}) {
    return {
        LsReunions, Syn,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardAG));



// WEBPACK FOOTER //
// ./src/components/Accueil/CardAG.js